import { makeStyles } from '@material-ui/core'
import theme from 'theme'

export default makeStyles(() => ({
  descriptionTypography: {
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
  },

  backgroundColor: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.dai.lightBlue,
  },
}))
